import SideNavigation from "../components/navigation/SideNav.vue";
import TopNavigation from "../components/navigation/TopNav.vue";
import TrashEventsSideSlider from "../components/trashEventsSideSlider/trashEventsSideSlider.vue";
import LogRocket from "logrocket";
import moment from "moment";
import ifvisible from "ifvisible.js";
import { createNamespacedHelpers } from "vuex";
import PrintHeader from "../components/printHeader/printHeader.vue";

const {
		mapActions: userActions,
		mapGetters: userGetters
	} = createNamespacedHelpers("user"),
	{mapActions: categoriesActions} = createNamespacedHelpers("categories"),
	{
		mapMutations: filtersMutations,
		mapActions: filtersActions
	} = createNamespacedHelpers("filters");

export default {

	data() {
		return {
			showDashboard: false,
			showFilters: true,
			sessionRecordingStarted: false
		};
	},

	computed: {
		...userGetters([
			"activeOutlet",
			"activeProperty",
			"properties"
		])
	},

	methods: {
		destroyFilters,
		reloadPage,
		endSession,
		startSession,
		forceEndSessionOnLogout,

		...userActions([
			"getMe"
		]),

		...filtersMutations([
			"setActiveWasteType",
			"setActiveDate"
		]),

		...filtersActions([
			"selectPeriod"
		]),

		...categoriesActions([
			"fetchCategories"
		])
	},

	components: {
		SideNavigation,
		TopNavigation,
		TrashEventsSideSlider,
		PrintHeader
	},

	beforeMount() {
		const language = localStorage.getItem("language") || "en";

		moment.locale(language);
		localStorage.setItem("language", language);

		this.$eventBus.$on("destroyFilters", this.destroyFilters);
		this.$eventBus.$on("reloadData", this.reloadPage);
	},

	async mounted() {
		await this.getMe();
		this.$utils.initMixpanelBeforeTrack(this);
		this.fetchCategories();

		if (this.$sessionService.getAccessToken() && document.hasFocus()) {
			const IDLE_DURATION = 600;

			this.startSession(this);

			ifvisible.setIdleDuration(IDLE_DURATION);

			ifvisible.on("idle", () => {
				this.endSession(this);
			});

			ifvisible.on("wakeup", () => {
				this.startSession(this);
			});

			// Logrocket identify user with recording session
			LogRocket.identify(this.$utils.returnUserId(), {
				name: this.$utils.returnUserEmail(),
				email: this.$utils.returnUserEmail(),
			});
		}

		this.$eventBus.$on("userLoggedOutEndSession", this.forceEndSessionOnLogout);
	},

	beforeDestroy() {
		this.$eventBus.$off("destroyFilters", this.destroyFilters);
		this.$eventBus.$off("reloadData", this.reloadPage);
		this.$eventBus.$off("userLoggedOutEndSession", this.forceEndSessionOnLogout);
	}

};


function forceEndSessionOnLogout() {
	mixpanel.track("Session started");
}

function endSession(app) {

	if (!app.sessionRecordingStarted)
		return;


	app.sessionRecordingStarted = false;
	mixpanel.track("Session started");
}


function startSession(app) {

	if (app.sessionRecordingStarted)
		return;


	app.sessionRecordingStarted = true;
	mixpanel.time_event("Session started");
}


function destroyFilters() {
	this.showFilters = false;

	this.selectPeriod("month");
	this.setActiveWasteType("avoidable");

	this.$nextTick(() => {
		this.showFilters = true;
		this.$eventBus.$emit("setCalendar");
		this.$eventBus.$emit("reloadComponentData");
	});

}

function reloadPage() {
	location.reload();
}
